import { Controller } from '@hotwired/stimulus'
import { application } from './application'

let asyncControllerLoaded = false

export default class extends Controller {
  connect () {
    if (!asyncControllerLoaded) {
      asyncControllerLoaded = true
      import('./pie_chart_controller_async').then((controller) => {
        application.load([{ identifier: 'pie-chart', controllerConstructor: controller.default }])
      }, () => { })
    }
  }
}
